import { create } from 'zustand';

import {
  GetIpv4GroupsParams,
  GetIpv6GroupsParams,
  GetPlansParams,
  GetVelocidadesParams,
  getIpv4Groups,
  getIpv6Groups,
  getPlanTypes,
  getPlanTypesParams,
  getPlans,
  getServicesType,
  getServicesTypeParams,
  getVelocidades,
} from '@/shared/actions/erp';
import {
  Ipv4Group,
  Ipv6Group,
  Plan,
  PlanesCorporativos,
  PlanesCorporativosParams,
  PlanType,
  ServicesType,
  Velocidad,
} from '@/shared/interfaces';
import { getPlanCorporativo } from '@/shared/actions/erp/planes';

interface PlanState {
  typeServive: ServicesType[];

  plans: Plan[];
  plansCorporativos: PlanesCorporativos[];
  ipv4Groups: Ipv4Group[];
  ipv6Groups: Ipv6Group[];
  velocidades: Velocidad[];
  planTypes: PlanType[];

  isLoadingPlans: boolean;
  isLoadingPlansCorporativos: boolean;
  isLoadingIpv4Groups: boolean;
  isLoadingIpv6Groups: boolean;
  isLoadingVelocidades: boolean;
  isLoadingPlanTypes: boolean;
  isLoadingTypeService: boolean;

  getPlans: (params?: GetPlansParams) => Promise<void>;
  getPlansCorporativos: (params?: PlanesCorporativosParams) => Promise<void>;
  getIpv4Groups: (params?: GetIpv4GroupsParams) => Promise<void>;
  getIpv6Groups: (params?: GetIpv6GroupsParams) => Promise<void>;
  getVelocidades: (params?: GetVelocidadesParams) => Promise<void>;
  getPlanTypes: (params?: getPlanTypesParams) => Promise<void>;
  getTypeService: (params?: getServicesTypeParams) => Promise<void>;
}

export const usePlanStore = create<PlanState>(set => ({
  plans: [],
  plansCorporativos: [],
  ipv4Groups: [],
  ipv6Groups: [],
  velocidades: [],
  planTypes: [],

  typeServive: [],

  isLoadingPlans: false,
  isLoadingPlansCorporativos: false,
  isLoadingIpv4Groups: false,
  isLoadingIpv6Groups: false,
  isLoadingVelocidades: false,
  isLoadingPlanTypes: false,
  isLoadingTypeService: false,

  getPlans: async params => {
    set({ isLoadingPlans: true });
    const res = await getPlans(params);

    set({ plans: res.data.data, isLoadingPlans: false });
  },
  getPlansCorporativos: async params => {
    set({ isLoadingPlansCorporativos: true });
    const res = await getPlanCorporativo(params);

    set({ plansCorporativos: res.data.data, isLoadingPlansCorporativos: false });
  },
  getIpv4Groups: async params => {
    set({ isLoadingIpv4Groups: true });
    const res = await getIpv4Groups(params);

    set({ ipv4Groups: res.data.data, isLoadingIpv4Groups: false });
  },
  getIpv6Groups: async params => {
    set({ isLoadingIpv6Groups: true });
    const res = await getIpv6Groups(params);

    set({ ipv6Groups: res.data.data, isLoadingIpv6Groups: false });
  },
  getVelocidades: async params => {
    set({ isLoadingVelocidades: true });
    const res = await getVelocidades(params);

    set({ velocidades: res.data.data, isLoadingVelocidades: false });
  },
  getPlanTypes: async params => {
    set({ isLoadingPlanTypes: true });
    const res = await getPlanTypes(params);

    set({ planTypes: res.data.data, isLoadingPlanTypes: false });
  },
  
  getTypeService: async params => {
    set({ isLoadingTypeService: true });
    const res = await getServicesType(params);
    set({ typeServive: res.data.data, isLoadingTypeService: false });
  },
}));
